import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import b from 'b_';
import ValueStore from '../../stores/helpers/ValueStore';
import Icon from '../Icon/Icon';
import { FTBody } from '../Fuse/Text';
import RadioButtonStore from '../../stores/RadioButtonStore';
import './FuseRadioButton.css';


const block = b.lock('FuseRadioButton');

class FuseRadioButton extends Component {
    static propTypes = {
        store: PropTypes.oneOfType([RadioButtonStore.PropType.isRequired, ValueStore.PropTypes.isRequired]),
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
        readOnly: PropTypes.bool,
        disabled: PropTypes.bool,
        focus: PropTypes.bool,
        hover: PropTypes.bool,
        active: PropTypes.bool,
        label: PropTypes.node,
        qa: PropTypes.string,
    };

    state = {
        focus: false,
    };

    onClick = (event, value) => {
        this.props.store.setValue(value);
        if (event.pageX !== 0 && event.pageY !== 0) {
            this.setState({ focus: false });
        }
    };

    render() {
        const {
            store,
            value,
            label,
            className,
            readOnly,
            disabled,
            focus,
            hover,
            active,
            qa,
            ...inputProps
        } = this.props;

        const checked = store.equals(value);

        return <div className={className}>
            <label
                className={cn(block({
                    checked,
                    disabled: readOnly || disabled,
                    focused: focus === undefined ? this.state.focus : focus,
                    hover: hover === true,
                    active: active === true,
                }))}
                data-qa={qa}
            >
                <input
                    className={block('Input')}
                    type="radio"
                    name={value + ''}
                    disabled={readOnly || disabled}
                    defaultChecked={checked}
                    onClick={(event) => this.onClick(event, value)}
                    onFocus={() => this.setState({ focus: true })}
                    onBlur={() => this.setState({ focus: false })}
                    data-qa={`${qa ? (qa + '-') : ''}input`}
                    {...inputProps}
                />
                <div className={block('Circle')} data-qa={`icon ${checked ? 'checked' : 'unchecked'}`}>
                    {checked ? <Icon
                        className={block('IconChecked', { disabled: readOnly || disabled })}
                        type="radio_button_checked"
                    /> : <Icon
                        className={block('IconNotChecked', { disabled: readOnly || disabled })}
                        type="radio_button_unchecked"
                    />}
                </div>
                <FTBody className={block('Text', { disabled, readOnly })}>{label}</FTBody>
            </label>
        </div>;
    }
}

export default observer(FuseRadioButton);
